export const HIDDEN_TEMPLATE_TAGS = [
    "automations",
    "drips",
    "broadcasts",
    "autoresponders",
];